import './index.css'

import * as React from 'react'
import { MdInfo as InfoIcon } from '@react-icons/all-files/md/MdInfo'
import { connect } from 'react-redux'
import CustomScrollbars from 'components/ui/scrollbar'
import Tooltip from 'components/ui/tooltip'

function mapStateToProps(state): any {
  return {
    elements: state.uiElements.elements,
  }
}

type OwnProps = {
  readonly children?: React.ReactNode
  readonly base?: React.ReactNode
  // `base` is wrapped in div: `<div>{base}</div>``
  readonly iconColor?: string
  readonly maxWidth?: string
  readonly id?: string
  readonly customScrollbars?: boolean
  readonly noCssWrapper?: boolean
  readonly position?: 'bottom' | 'top'
}
type StateProps = {
  readonly elements: Record<string, any>[]
}
type Props = OwnProps & StateProps

/**
 * Help tooltip component that displays contextual help information
 * Can show content from UI elements store or children, with optional scrollbars
 */
class HelpTooltip extends React.Component<Props> {
  _getTooltipContent() {
    const { children, elements, id } = this.props
    const element = elements.find(item => item.element_name === id)

    if (element) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: element.content,
          }}
        />
      )
    } else if (children) {
      return children
    } else {
      return <span>&nbsp;</span>
    }
  }

  _renderBase() {
    const { base } = this.props
    if (base) return base
    return (
      <div className="HelpTooltip_IconCont hidden-phone">
        <InfoIcon
          className="HelpTooltip_Icon"
          size={14}
          color={this.props.iconColor}
        />
      </div>
    )
  }

  _renderWrappedBase() {
    const base = this._renderBase()

    if (this.props.noCssWrapper) return base
    // TODO: use `HelpTooltip_OuterCont` only with `HelpTooltip_IconCont`
    return <div className="HelpTooltip_OuterCont">{base}</div>
  }

  render() {
    let tooltipContent = this._getTooltipContent()

    if (this.props.customScrollbars) {
      tooltipContent = (
        <CustomScrollbars vertical autoHeight color="light">
          {tooltipContent}
        </CustomScrollbars>
      )
    }

    const contStyle = this.props.maxWidth
      ? {
          maxWidth: this.props.maxWidth,
        }
      : undefined
    return (
      <React.Fragment>
        <Tooltip
          content={
            <div className="HelpTooltip_Cont" style={contStyle}>
              {tooltipContent}
            </div>
          }
          position={this.props.position}
        >
          {this._renderWrappedBase()}
        </Tooltip>
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps)(
  HelpTooltip,
) as React.ComponentType<OwnProps>
